import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import ChecklistsLoader, { useChecklists } from '../_load/ChecklistsLoader'
import SelectAllChecklistsLink from '../SelectAllChecklistsLink'

const ChecklistsFilterSideModal = ({ label, field, onClose, ...props }) => {
  field = field || 'checklistIds'
  label = label || 'Questionários'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useChecklists}
      onSubmit={handleChange(field)}
      Loader={ChecklistsLoader}
      useSearch
      renderHeaderRightContent={params => <SelectAllChecklistsLink {...params} />}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default ChecklistsFilterSideModal
